import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const UserProfile = () => {
  const location = useLocation();
  const userId = location.state?.userId;
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (userId) {
      fetch(`https://schoolofservice.co.za/backend/get_user_profile.php?userID=${userId}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setProfileData(data.data);
          } else {
            setError(data.message || 'Failed to fetch profile data.');
          }
          setLoading(false);
        })
        .catch(() => {
          setError('An error occurred while fetching the profile data.');
          setLoading(false);
        });
    } else {
      setError('Invalid user ID.');
      setLoading(false);
    }
  }, [userId]);

  if (loading) return <p>Loading profile...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container mt-4">
      <h2>User Profile</h2>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5>Name: {profileData.firstname}</h5>
          <p> <i className="fa fa-picture-o" aria-hidden="true"></i>: {profileData.surname}</p>
          <p><i className="fa fa-address-card" aria-hidden="true"></i>: {profileData.address}</p>
          <p><i className="fa fa-phone" aria-hidden="true"></i>: {profileData.contact}</p>
          <p><i className="fa fa-envelope" aria-hidden="true"></i>: {profileData.email}</p>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
